<template>
	<div @click="closeMenu" class="modal-background"></div>
</template>

<script>
export default {
  name: 'ModalBackground',
  methods: {
    closeMenu () {
      this.$emit('closeMenu', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-background {
  background-color: #000000;
  opacity: 0.8;
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/LP/atoms/ModalBackground.vue